export var EnrollPatientCaseSource;
(function (EnrollPatientCaseSource) {
    EnrollPatientCaseSource["patientportal"] = "patientportal";
    EnrollPatientCaseSource["providerportal"] = "providerportal";
})(EnrollPatientCaseSource || (EnrollPatientCaseSource = {}));
//# sourceMappingURL=EnrollPatientCaseSource.js.map